/* template */
<template><drawer-bottom :show="(show)" title="差旅制度" @close="close"><div class="es-travel-container"><div class="es-travel-container-header"><span>国内火车票</span></div><div class="es-travel-container-body"><div class="es-travel-container-body-item"><div class="es-travel-container-body-item-1">{{ trainInfoContent[0].name }}</div><span class="es-travel-container-body-item-2">{{ trainInfoContent[0].value }}</span></div><div class="es-travel-container-body-item"><div class="es-travel-container-body-item-1">{{ trainInfoContent[1].name }}</div><span class="es-travel-container-body-item-2">{{ trainInfoContent[1].value }}</span></div></div></div></drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf17fe788"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-travel-container
    padding 8px 15px 0
    .es-travel-container-header
      display flex
      align-items center
      font-weight 500
      font-size 16px
      color $train-color-333
      margin-bottom 15px
      &::before
        display inline-block
        content ''
        width 3px
        height 15px
        margin-right 8px
        background #1473FF
    .es-travel-container-body
      .es-travel-container-body-item
        display flex
        font-size 14px
        font-weight 400
        margin-bottom 16px
        .es-travel-container-body-item-1
          width 84px
          color $train-color-666
          margin-right 28px
        .es-travel-container-body-item-2
          width 259px
          color $train-color-333
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf17fe788"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexf17fe788%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexf17fe788%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mf17fe788"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexf17fe788/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
